import { Box, Typography, TextField, Grid, Button } from "@mui/material";
import React from "react";
import SignatureCanvas from "react-signature-canvas";

export const Step8 = (props) => {
  const { register, errors, setSignaturePad, signaturePad } = props;
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">Declaración Responsable</Typography>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {/* Campo Lugar */}
        <Grid item xs={12} md={6}>
          <TextField
            {...register("lugar", {
              required: "El lugar de declaración es obligatorio",
            })}
            label="Lugar de declaración"
            fullWidth
            required
            error={!!errors.lugar}
            helperText={errors.lugar?.message}
          />
        </Grid>

        {/* Campo Fecha */}
        <Grid item xs={12} md={6}>
          <TextField
            {...register("fecha", {
              required: "La fecha de declaración es obligatoria",
              validate: (value) => {
                const isValidDate = !isNaN(Date.parse(value));
                return isValidDate || "Introduce una fecha válida (YYYY-MM-DD)";
              },
            })}
            label="Fecha de declaración"
            type="date"
            fullWidth
            required
            InputLabelProps={{ shrink: true }} // Para que el label no se superponga al valor
            error={!!errors.fecha}
            helperText={errors.fecha?.message}
          />
        </Grid>
      </Grid>

      <Box
        sx={{
          maxHeight: "300px", // Limitar la altura
          overflowY: "auto", // Habilitar el scroll vertical
          border: "1px solid #ccc", // Borde para el contenedor
          padding: "16px", // Espaciado interior
          borderRadius: "8px", // Bordes redondeados para un diseño más bonito
        }}
      >
        <Typography variant="subtitle1">
          El firmante declara bajo su plena responsabilidad que toda la
          información y documentación presentada en este formulario, así como
          los documentos adjuntos, son verídicos, completos y correctos, y que
          no contienen datos falsos, engañosos ni distorsionados de ninguna
          índole. Asimismo, el firmante se compromete a que la información
          proporcionada refleja fielmente los hechos, circunstancias y detalles
          relacionados con el siniestro descrito, y que ha sido obtenida de
          manera legal y conforme a la normativa vigente. El firmante entiende
          que cualquier falsedad, omisión o manipulación de los datos
          proporcionados puede ser motivo de acciones legales, y que, en caso de
          ser necesario, se podrán tomar las medidas pertinentes para verificar
          la autenticidad de la información. El firmante también reconoce que
          asume la responsabilidad total sobre las consecuencias de proporcionar
          información errónea o inexacta.
        </Typography>
      </Box>
      <Typography variant="subtitle1">Firma:</Typography>
      <SignatureCanvas
        ref={(ref) => setSignaturePad(ref)}
        canvasProps={{
          height: 200,
          style: { border: "1px solid #ccc", width: "100%" },
        }}
      />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => signaturePad.clear()}
        sx={{ mt: 1 }}
      >
        Limpiar Firma
      </Button>
    </Box>
  );
};

export default Step8;
